/**
 * 광고 소재 조사(meta) React Query 키.
 *
 * ## 규약
 * - 키 모양은 `[도메인, 조회이름, …인자를 «값으로» 펼친 것]` — 객체를 통째로 넣지 않는다.
 * - `*Root()` 는 `resetQueries`/`removeQueries` 대상용 접두 키다.
 * - ES 질문이라 `staleTime` 은 60초를 명시한다(같은 시그니처면 같은 결과).
 *
 * ## ⚠️ 목록 키는 «서명 + 시작 위치» 둘이다
 * `toAdListScopeKey(filters)` 가 「다시 조회해야 하는가」를 판정하는 문자열이고, 페이지는
 * 그와 **별개의 축**이다(조건이 같아도 3페이지는 다른 질문) — 캐시 정체성은 그 둘이다.
 * 필터 상태를 그대로 넣으면 `Set` 이 매번 새 참조라 캐시가 통째로 죽는다.
 *
 * ## ⚠️ 단건 상세는 광고 id 하나가 정체성이다
 * 목록이 준 «씨앗»(카드에 있던 값)은 키에 넣지 않는다 — 같은 광고면 단건 응답이 같고,
 * 씨앗은 그 위에 화면이 덧대는 값이라 캐시를 가를 이유가 없다.
 *
 * 새 조회는 이 아래에 보탠다.
 */
export const metaKeys = {
  all: ['meta-ads'] as const,

  // ── 광고 목록(페이지 단위) ──────────────────────────────────────────────────
  adListRoot: () => [...metaKeys.all, 'ad-list'] as const,
  /**
   * @param scopeKey `toAdListScopeKey(filters)`
   * @param from 시작 위치 — `(page - 1) * AD_PAGE_SIZE`
   */
  adList: (scopeKey: string, from: number) => [...metaKeys.adListRoot(), scopeKey, from] as const,

  // ── 광고 패싯(필터·페이지 무관, 전역) ────────────────────────────────────────
  /**
   * ⚠️ **인자가 없다.** 패싯·counts·latestDate 는 `isBeautyAd`+미리보기만 걸고 전체를
   * 세므로 필터·페이지가 바뀌어도 결과가 같다 — 세션 안에서 키가 하나다(긴 staleTime).
   */
  adFacets: () => [...metaKeys.all, 'ad-facets'] as const,

  // ── 광고 단건 상세 ──────────────────────────────────────────────────────────
  adDetailRoot: () => [...metaKeys.all, 'ad-detail'] as const,
  /** @param adId 광고 문서 id (`AdCreative.id`) */
  adDetail: (adId: string) => [...metaKeys.adDetailRoot(), adId] as const,
};
